module.exports = __webpack_public_path__ + "static/media/dhaam_logo.a9e7eb22.png";